<svg class="loader" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle [class.loader__contrast]="loaderContrast()" cx="50" cy="50" r="45" />
</svg>
